import React from "react";
import "./productcostsection.css";
import { MdArrowOutward } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const ProductCostSection = () =>{
    const productCostInfo = [
        {
            title: "Stock API",
            type: "Free",
            description: "Stock Archives API provides key endpoint of historic for information in an easy to api",
            subtitle: "Historical Balance Sheet, Income Statement, Cashflow"
        }/*,{
            title:"Stock Dashboard",
            type: "Paid",
            description: "Stock archives stock dash research dashboard allow you to customize your research experience with customizable data widget, deep research, and customer insight.",
            subtitle: "Cusomizable Dashboard, More indepth data points, customer insight"
        }*/
    ]

    const navigate = useNavigate();

    const navigateToSignUp = () =>{
        navigate("/login?fromSignup=true")
    }


    return(
        <div className="product-item-cost-section">
            {productCostInfo.map((item,index) =>(
                <div>
                    <h3>{item.title}: </h3>
                    <div className="product-item-cost-container">
                        <div className="product-info-cost-container">
                            <p><strong>{item.type}</strong></p>
                            <p>{item.description}</p>
                            <p>{item.subtitle}</p>
                        </div>
                        <div className="product-button-cost-container{">
                            <button onClick={navigateToSignUp} className="product-button-cost"><MdArrowOutward className="product-button-logo-cost" /></button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ProductCostSection;